import { useFeature } from '@mafc/appshell';
import { CookieUtils } from '@mafc/common';
import useNewC4Journey from 'hooks/useNewC4Journey';
import { setPlasticBagUserConsent } from 'pages/OrderList/redux/plasticBagUserConsent.action';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ICartState } from '../redux/reducer';

const useSustainabilityConsent = () => {
  const { cart, newCart } = useSelector((state: { newCart: ICartState; cart: ICartState }) => ({
    newCart: state.newCart,
    cart: state.cart,
  }));

  const isNewJourney = useNewC4Journey();

  const { isSustainabilityConsentRequired = false } = isNewJourney
    ? newCart.cartData
    : cart.cartData;
  const dispatch = useDispatch();

  const isFreeDeliveryConsentStoredInCookie =
    CookieUtils.getPackageFreeDelivery() === 'true' ||
    CookieUtils.getPackageFreeDelivery() === 'false';

  const isSingleUseBagsSupported = useFeature('single-use-plasticbag-enabled').on;

  const [isConsentFormOpen, toggleConsentForm] = useState(false);

  const shouldOpenTheConsent =
    !isConsentFormOpen &&
    isSustainabilityConsentRequired &&
    isSingleUseBagsSupported &&
    !isFreeDeliveryConsentStoredInCookie;

  const closeConsentForm = () => {
    toggleConsentForm(false);
  };

  const openConsentForm = () => {
    toggleConsentForm(true);
  };

  const setUserConsent = (data: boolean) => {
    dispatch(setPlasticBagUserConsent(data));
  };

  return {
    toggleConsentForm,
    shouldOpenTheConsent,
    isConsentFormOpen,
    closeConsentForm,
    setUserConsent,
    isSustainabilityConsentRequired,
    isSingleUseBagsSupported,
    openConsentForm,
  };
};

export default useSustainabilityConsent;
